"use client";
import Image from "next/image";
import { useTranslation } from "@/app/i18n/client";
import Conector from "@/assets/images/decorators/conector.webp";
import EquilibrioVee from "@/assets/images/decorators/equilibrio-Vee.webp";
import { CustomDiv, InlineDiv } from "@/common/divs";
import { AlmostBoldText, LightText } from "@/common/texts";

const EconomySection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <CustomDiv
      className="global-padding"
      paddingY="20px"
      style={{ paddingLeft: "108px", position: "relative" }}
      background="#FFF7E4"
    >
      <InlineDiv className="economy-container">
        <CustomDiv
          style={{ maxWidth: "600px", marginTop: "70px", zIndex: "9" }}
        >
          <AlmostBoldText fontSize="34px" style={{ lineHeight: "45px" }}>
            {t("landing.sostenibility")}
          </AlmostBoldText>
          <LightText fontSize="18px" className="economy-light-text">
            {t("landing.purchases")}
          </LightText>
        </CustomDiv>
        <Image
          style={{ marginTop: "0px", minWidth: "200px", zIndex: "9" }}
          src={EquilibrioVee}
          alt="Equilibrio Vee"
          width={500}
          height={500}
          className="h-[500px]"
        />
        <Image
          className="hide-decorators economy-conector-image"
          src={Conector}
          alt="Conector"
        />
      </InlineDiv>
    </CustomDiv>
  );
};

export default EconomySection;
